export default "__VITE_ASSET__ClkL7ebp__"